import React, { useEffect } from "react";
import { Box, Button, Grid } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import AppForm from "components/Shared/AppForm";
import { BASE_CONSTANTS } from "constants/baseConstants";
import { useNavigate } from "react-router-dom";
import BaseTextField from "components/Shared/Base/BaseTextField";

export const VendorStaffForm = ({
  vendorStaffDetail = null,
  isBusy = false,
  onSubmit = () => {},
}) => {
  const navigate = useNavigate();

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      phone: "",
      email: ""
    },
  });

  useEffect(() => {
    if (vendorStaffDetail) {
      reset({
        name: vendorStaffDetail.name ?? "",
        email: vendorStaffDetail.email ?? "",
        phone: vendorStaffDetail.phone ?? ""
      });
    }
  }, [vendorStaffDetail, reset]);

  return (
    <AppForm loading={isBusy}>
      <AppForm.Content>
        <Grid container spacing={BASE_CONSTANTS.SPACING_LG}>
          <Grid item xs={6}>
            <Controller
              name="name"
              rules={{ required: "Name is Required" }}
              control={control}
              render={({ field }) => (
                <BaseTextField
                  {...field}
                  fullWidth
                  label="Name"
                  required
                  error={!!errors?.name}
                  helperText={errors?.name?.message}
                />
              )}
            />
          </Grid>
          {!vendorStaffDetail && (<Grid item xs={6}>
            <Controller
              name="email"
              control={control}
              rules={{ required: "Email Address is Required" }}
              render={({ field }) => (
                <BaseTextField
                  {...field}
                  fullWidth
                  label="Email"
                  required
                  error={!!errors?.email}
                  helperText={errors?.email?.message}
                />
              )}
            />
          </Grid>)}
          <Grid item xs={6}>
            <Controller
              name="phone"
              control={control}
              rules={{ required: "Phone Number is Required" }}
              render={({ field }) => (
                <BaseTextField
                  {...field}
                  fullWidth
                  label="Phone"
                  required
                  error={!!errors?.phone}
                  helperText={errors?.phone?.message}
                />
              )}
            />
          </Grid>
        </Grid>

        <Box
          paddingY={2}
          gap={2}
          style={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button disabled={isBusy} onClick={() => navigate(-1)}>
            Cancel
          </Button>
          <Button
            variant="contained"
            disabled={isBusy}
            onClick={handleSubmit((data) => onSubmit(data))}
          >
            {vendorStaffDetail ? "Update" : "Add"}
          </Button>
        </Box>
      </AppForm.Content>
    </AppForm>
  );
};

export default VendorStaffForm;